module.exports = __webpack_public_path__ + "static/media/grab.ff6c8e67.svg";